export default "__VITE_ASSET__BwmKFo2L__"